module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/paula-czyz-d3437b56a28f52f4e755c70b12ad70b7.webp";